import { BaseWebComponentController, IListenerConfig } from '../../../framework/BaseWebComponentController';
import { PhasrMonitoredRulesWebComponent } from '../component/PhasrMonitoredRulesWebComponent';
import { PhasrMonitoredRulesView } from '../view/PhasrMonitoredRulesView';
import { templatePhasrMonitoredRules } from '../view/template';

export class PhasrMonitoredRulesController extends BaseWebComponentController {
  public component: PhasrMonitoredRulesWebComponent;
  public view: PhasrMonitoredRulesView;
  public viewConstructor: typeof PhasrMonitoredRulesView;

  constructor(component: PhasrMonitoredRulesWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: PhasrMonitoredRulesView,
      viewTemplate: templatePhasrMonitoredRules
    });
  }

  public computeEventListeners(): IListenerConfig[] {
    return [];
  }
}